export default "__VITE_ASSET__Bc2vMw$h__"